import React, { useState } from 'react'
import './Index.css'
import bgImage from '../../assets/jpg/Payment/galaxy.png'
import { cashfreeSandbox, cashfreeProd } from 'cashfree-pg-sdk-javascript'
import { useParams } from 'react-router';

const Payment = (props) => {
  const [isValidAmount, setValid] = useState(true);
  let {token} = useParams();
  let screenHeight = window.innerHeight;
  let screenWidth = window.innerWidth;
  console.log(`Window height: ${screenHeight} and width: ${screenWidth}`);
  //console.log('Passed token: ' + token);

  const paymentHandler = () => {
    console.log('Calling wallet api');
    var headers = {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
    //console.log(`Request headers: ${JSON.stringify(headers)}`);
    let paymentAmount = document.getElementById("amount").value;
    console.log(`Requested payment for: ${paymentAmount}`);
    if (paymentAmount >= 5) {
      setValid(true);
      fetch(process.env.REACT_APP_STAR_HUNT_WALLET_TOPUP_URL, {
        method: 'POST',
        headers,
        body: JSON.stringify({amount: paymentAmount})
      })
      .then(res => {
        if (res.ok) {
          res.json().then(json => {
            //console.log(`API response: ${JSON.stringify(json)}`);
            let paymentSessionId = json.data.paymentSessionId;
            //console.log(`Payment session id: ${json.data.paymentSessionId}`);
            console.log(`Process env: ${process.env.REACT_APP_ENV}`);
            if (process.env.REACT_APP_ENV === "prod") {
              console.log(`Calling cashfree production`);
              const cf = new cashfreeProd.Cashfree(paymentSessionId);
              cf.redirect();
            } else {
              console.log(`Calling cashfree sandbox`);
              const cf = new cashfreeSandbox.Cashfree(paymentSessionId);
              cf.redirect();
            }
          });
        }
      })
      .catch(err => {
        console.error('Error calling wallet topup api: ' + err);
      });
    } else {
      setValid(false);
    }
  }
  /* commenting amount presets for now
          <input className="amount-preset-left" type="submit" value="Rs. 30"/>
          <input className="amount-preset-centre" type="submit" value="Rs. 50"/>
          <input className="amount-preset-right" type="submit" value="Rs. 100"/>
  */

  return (
    <div className="main" >
        <img className="bg-image" alt="f" src={bgImage}>
        </img>
        <div className="container-box">
          <div className="text-heading">
            Please enter the amount to add
          </div>
          <input id='amount' className="amount" type='text'></input>
          <hr className="amount-input-line"/>
          { !isValidAmount ? (<div className="min-amount-msg">Minimum amount is Rs. 5</div>) : (<div className="min-amount-msg"></div>)};
          <input className="add-money" type="submit" value="Add Money" onClick={paymentHandler}/>
        </div>
    </div>
  )
}

export default Payment
